
import { getWeekList, formatterHour } from '@/utils/common';
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class extends Vue {
  @Prop() info!: any;
  @Prop({ default: 1 }) index!: number;
  @Prop() lastIndex!: boolean;
  @Prop() isDetail!: boolean;
  promotion_days: any = [];

  weekList: Array<any> = getWeekList();
  changeTime(e: string, key: string, time: { start: number; end: number; startStr?: string; endStr?: string }) {
    const str = e.split(':');
    const hourstr = str[0];
    const minutestr = str[1];
    (<any>time)[key] = Number(hourstr) * 60 * 60 + Number(minutestr) * 60;
    // console.log(e, key, time, 11);
  }
  addTime() {
    this.info.promotion_periods.push({ startStr: '', endStr: '' });
  }
  minusTime(index: number) {
    this.info.promotion_periods.splice(index, 1);
  }

  addRulesTime() {
    this.$emit('addRulesTime');
  }
  delRulesTime() {
    this.$emit('delRulesTime', this.index);
  }
  mounted() {
    this.info.promotion_periods.forEach((item: any) => {
      this.$set(item, 'startStr', `${formatterHour(item.start)}`);
      this.$set(item, 'endStr', `${formatterHour(item.end)}`);
    });
    if (!this.info.promotion_days) {
      this.$set(this.info, 'promotion_days', []);
    }
    this.$set(this.info, 'free_time', this.info.free_duration);
  }
}
